// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__jIIwT","title":"Info_title__2G7cm","links":"Info_links__X1Gw-","link":"Info_link__1SWXG","logo":"Info_logo__bO9uC"};